import React from 'react';
import { Header } from './style';
import { Row } from '../../Layouts';
import { Text } from '../../UI/Text';
import { Icon } from '../../Components/Icons/Icons';
import { timeFormats } from '../../../Constants/timeFormats';
import { getFormattedDateFromTimestamp } from '../../../Utils/timeConvertorHelper';

export const RightHeader = ({ onClear, start, name }) => {
    return (
        <Header>
            <Row>
                <Text weight={'bold'} fontSize={16} opacity={0.5}>
                    {getFormattedDateFromTimestamp(start, timeFormats.INCOMPLETE_TIME)}
                </Text>
                <Text marginLeft={'20px'} weight={'bold'} fontSize={16}>
                    {name}
                </Text>
            </Row>
            <Icon.Box cursor={'pointer'} onClick={onClear} size={'20x20'}>
                <Icon.Close />
            </Icon.Box>
        </Header>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Containers/CheckIn/RightHeader.js